import { render, staticRenderFns } from "./StudentResultRow.vue?vue&type=template&id=95b6acc4&scoped=true"
import script from "./StudentResultRow.vue?vue&type=script&lang=js"
export * from "./StudentResultRow.vue?vue&type=script&lang=js"
import style0 from "./StudentResultRow.vue?vue&type=style&index=0&id=95b6acc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b6acc4",
  null
  
)

export default component.exports